import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSend"><Path d="M14.3607 22.9387L21.6554 2.3233L1.00781 9.94701L10.2515 13.772L14.3607 22.9387Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSend;
